"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = validatePhoneNumberUK;
var _startsWith = _interopRequireDefault(require("lodash/startsWith"));
var _replaceStringVars = _interopRequireDefault(require("../../utils/string/replaceStringVars"));
var _startsFromAny = _interopRequireDefault(require("../../utils/string/startsFromAny"));
var _regex = require("../regex");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function isUkMobilePhoneNumber(number) {
  return (0, _startsWith["default"])(number, '07');
}
function isUkLandlinePhoneNumber(number) {
  return (0, _startsFromAny["default"])(number, ['01', '02', '03', '08']);
}
function isUkAsInternationalPhoneNumber(number) {
  return (0, _startsWith["default"])(number, '+44');
}
function isInternationalPhoneNumber(number) {
  return (0, _startsWith["default"])(number, '+') && number.length > 2;
}
function validateUkMobilePhoneNumber(number, validationMessageKeys) {
  if (number.length < 11) {
    return (
      // TODO minLengthMobile could be removed if nobody is found to be passing it in from outside the UI kit
      validationMessageKeys.minLengthMobile || validationMessageKeys.minLength
    );
  }
  if (number.length > 11) {
    return validationMessageKeys.maxLength;
  }
  return undefined;
}
function validateUkLandlinePhoneNumber(number, validationMessageKeys) {
  if (number.length < 10) {
    return validationMessageKeys.minLength;
  }
  if (number.length > 11) {
    return validationMessageKeys.maxLength;
  }
  return undefined;
}
function validateUkPhoneNumber(number, validationMessageKeys) {
  if (number !== '' && !_regex.phoneNumberUkRegex.test(number)) {
    return (0, _replaceStringVars["default"])(validationMessageKeys.invalid, {
      country: 'United Kingdom'
    });
  }
  return undefined;
}
function validatePhoneNumberUK(number, validationMessageKeys) {
  var transformedNumber = number.replace(/\s/g, '');
  if (isUkAsInternationalPhoneNumber(number)) {
    transformedNumber = "0".concat(number.substr(3));
  }
  if (isUkMobilePhoneNumber(transformedNumber)) {
    return validateUkMobilePhoneNumber(transformedNumber, validationMessageKeys);
  }
  if (isUkLandlinePhoneNumber(transformedNumber)) {
    return validateUkLandlinePhoneNumber(transformedNumber, validationMessageKeys);
  }
  if (isUkAsInternationalPhoneNumber(number)) {
    return validateUkPhoneNumber(transformedNumber, validationMessageKeys);
  }
  if (isInternationalPhoneNumber(transformedNumber)) {
    if (transformedNumber.length < 9) {
      return validationMessageKeys.minLengthInt;
    }
    return undefined;
  }
  return validateUkPhoneNumber(transformedNumber, validationMessageKeys);
}